import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

const useAddNewSelector = ({
  options: defaultOptions,
  addText,
  isMulti = false,
  onChange: onChangeValue,
  enable = true
}) => {
  const { t } = useTranslation('');
  const [isOpen, setIsOpen] = useState();

  const options = useMemo(() => (enable ? [...defaultOptions, { value: null, label: t(addText) }] : defaultOptions), [
    addText,
    defaultOptions,
    enable,
    t
  ]);

  const onChange = useCallback(
    (newId, input, isAdded, addedData) => {
      if (
        isMulti
          ? newId.includes(null) || newId.some((id) => typeof id === 'string')
          : typeof newId === 'string' || newId === null
      ) {
        setIsOpen(newId === null ? true : newId);
        input?.onChange?.(input?.value);
      } else {
        const value = newId === undefined ? null : newId;
        input?.onChange?.(value);
        onChangeValue?.(value, isAdded, addedData);
      }
    },
    [isMulti, onChangeValue]
  );

  return { isOpen, setIsOpen, options, onChange };
};

export default useAddNewSelector;
